import { atom } from "recoil";

export const pstatStore = atom({
	key: "pstatStore",
	default: {
		loaded: false,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		data: [],
		chart: { deposits: { total: [], count: [], first: [] }, withdrawals: { total: [], count: [] }, profit: [], players: [] },
		average: 0,
		total: 0,
		period: 0,
		range: false,
		offset: 0,
		limit: 0,
		sorting: {
			sortingColumn: {
				sortingField: "deposits",
			},
			sortingDescending: false,
		},
		currentOption: {
			group: false,
			payWay: false,
			period: false,
		},
		currentGroup: false,
		currentPayWay: false,
		currentPeriod: false,
	},
});
